import Vue from 'vue'
import VueResource from 'vue-resource';
import note from './vue/note.vue'

if($('#note_feature').length) {
    Vue.use(VueResource);
    new Vue({
        el: '#note_feature',
        components: {
            note
        }
    });
}